import React, { FC, useContext, useMemo } from 'react';
import { ThemeContext } from 'styled-components';

import { ReactComponent as InfoIcon } from '../../../icons/info.svg';
import { ReactComponent as HelpIcon } from '../../../icons/help.svg';
import { ReactComponent as TimelapsepIcon } from '../../../icons/timelapse.svg';
import { StyledMessage } from './InfoMessage.styles';
import { MessageProps } from '../Message';

export interface InfoMessageProps extends MessageProps {
  /** Use the `question` icon */
  question?: boolean;
  /** Use the `processing` icon */
  processing?: boolean;
}
const InfoMessage: FC<InfoMessageProps> = ({ children, question, processing, ...props }) => {
  const theme = useContext(ThemeContext);
  const Icon = useMemo(() => {
    if (question) {
      return HelpIcon;
    }

    if (processing) {
      return TimelapsepIcon;
    }

    return InfoIcon;
  }, [processing, question]);

  return (
    <StyledMessage
      iconColor={theme.colors.info}
      {...props}
      Icon={Icon}
    >
      {children}
    </StyledMessage>
  );
};

export default InfoMessage;
